import { render, staticRenderFns } from "./player-tree.vue?vue&type=template&id=1049d12c&"
import script from "./player-tree.vue?vue&type=script&lang=js&"
export * from "./player-tree.vue?vue&type=script&lang=js&"
import style0 from "./player-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports